import { IAppState } from '../../../AppModulesWrapper';

import { selectOfferId } from '.';

export function selectIsNewOffer(state: IAppState): boolean {
  const offerId = selectOfferId(state);

  return !offerId;
}
